var exports = {
  "k": "x4ddf2309--dd6230--container",
};

module.exports = exports;
